import React from 'react'

import { IContractNotification } from '@api'
import Notifications from 'components/Portfolio/Notifications'

const LeaseNotifications = ({
  floor,
  updateFloor,
}: {
  floor: any
  updateFloor: (floor: any) => void
}) => {
  const notificationsArr = floor?.notifications?.edges?.map(
    (n: any) => n.node
  ) as IContractNotification[]

  const updateNotifications = (nId: string, buildingId: string) => {
    const notificationArr = floor.notifications.edges.filter((notification: any) => {
      return notification.node.id !== nId
    })
    floor.notifications.edges = notificationArr
    updateFloor(floor)
  }

  return (
    <>
      <Notifications
        notifications={notificationsArr}
        buildingId={floor?.building?.id as string}
        iconcolor="#FF0000"
        customDismiss={(nId, buildingId) => updateNotifications(nId, buildingId)}
      />
    </>
  )
}

export default LeaseNotifications
